import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row gx-0 p-4 px-lg-5" }
const _hoisted_2 = {
  key: 0,
  class: "col-12"
}
const _hoisted_3 = { key: 1 }

import { onMounted, ref } from 'vue'
import LoadingSkeletonDefault from '@/skeletor/LoadingSkeletonDefault.vue'
import { eventoService } from '@/services/evento.service'
import DetailSeccion from '@/views/detail/DetailSeccion.vue'
import DetailSeccionSpecial from '@/views/detail/DetailSeccionSpecial.vue'
import { useStore } from 'vuex'
import { VuexStore } from '@/interfaces/VuexStore'
import { key } from '@/setup/store'


export default /*#__PURE__*/_defineComponent({
  __name: 'Home',
  setup(__props) {

const loading = ref(true)
const eventoVer = ref()
const { state, commit } = useStore<VuexStore>(key)

const resolveRequest = async () => {
  loading.value = true
  eventoVer.value = await eventoService.ver()
  loading.value = false
  commit('RESET_NAV')
}
onMounted(() => {
  resolveRequest()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(LoadingSkeletonDefault)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (_unref(state).evento?.fidelizacion)
            ? (_openBlock(), _createBlock(DetailSeccionSpecial, {
                key: 0,
                video: 
            eventoVer.value.id === 14
              ? '/video/promo_14.mp4'
              : undefined
          ,
                title: eventoVer.value.nombre,
                "sub-title": eventoVer.value.subtitulo,
                imgs: eventoVer.value.slider,
                html: eventoVer.value.descripcion
              }, null, 8, ["video", "title", "sub-title", "imgs", "html"]))
            : (_openBlock(), _createBlock(DetailSeccion, {
                key: 1,
                title: eventoVer.value.nombre,
                "sub-title": eventoVer.value.subtitulo,
                imgs: eventoVer.value.slider,
                html: eventoVer.value.descripcion
              }, null, 8, ["title", "sub-title", "imgs", "html"]))
        ]))
  ]))
}
}

})